import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { ErrorPage } from "@nju/feature-portal-wwt";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../../components/ClientSideRenderer";

export default function WwtError() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="extraNarrow" spacing="xl">
        <ClientSideOnly>
          <ErrorPage />
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
